export const PermitPaths = {
    Root: "permit",
    Create: "create",
    CreateDemo: "createdemo",
    Details: "details",
    PermitRequests: "permitrequests",
    HandleFlammableAtexPermitRequest: "handleflammableatexpermitrequest",
    RequestFlammableAtexPermit: "requestflammableatexpermit",
    RetrieveFlammableAtexPermit: "retrieveflammableatexpermit",
    Prepare: "prepare",
    PreparedPermits: "preparedpermits",
    Sign: "sign",
    Summary: "summary",
    Pdf: "pdf",
};
